(() => {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const variants = JSON.parse(root.querySelector('[data-wallet-data]').textContent).variants;
    const byId = new Map(variants.map(v => [String(v.id), v]));
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const currency = root.dataset.currency;
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency}).format(cents / 100);
    const route = window.Shopify?.routes?.root || '/';
    const rate = Number(window.Shopify?.currency?.rate) || 1;
    let count = 1;
    let ids = [String(root.dataset.default), null, null];
    let activeSlot = 0;
    // Restore this history entry after checkout, without leaking choices to a new visit.
    const saved = history.state?.tenLoveWallet;
    if (saved?.section === root.id && [1, 2, 3].includes(saved.count) &&
        Array.isArray(saved.ids) && saved.ids.length === 3 && byId.has(saved.ids[0]) &&
        saved.ids.every(id => id === null || byId.has(id))) {
      count = saved.count;
      ids = saved.ids.map((id, index) => saved.version === 2 || index < count ? id : null);
      if (Number.isInteger(saved.activeSlot) && saved.activeSlot >= 0 && saved.activeSlot < count) activeSlot = saved.activeSlot;
    }
    let busy = false;
    let stickyEligible = false;
    const form = $('[data-wallet-form]');
    const express = $('[data-wallet-express]');
    $('[data-variant-input]').disabled = false;
    const slides = $('[data-slides]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const photos = $$('.tlw-slide');
    const thumbs = $('.tlw-thumbs');
    let galleryIndex = Math.max(0, photos.findIndex(photo => photo.dataset.slideVariant === (ids[activeSlot] || ids[0])));
    let galleryWidth = 0;
    function updateGallery(index) {
      galleryIndex = Math.max(0, Math.min(photos.length - 1, index));
      $$('[data-slide]').forEach(button => button.setAttribute('aria-current', String(Number(button.dataset.slide) === galleryIndex)));
      $('[data-gallery-label]').textContent = `${photos[galleryIndex].dataset.photoName} · ${galleryIndex + 1} / ${photos.length}`;
      const thumb = $(`[data-slide="${galleryIndex}"]`);
      const rail = thumbs.getBoundingClientRect();
      const box = thumb.getBoundingClientRect();
      if (box.left < rail.left || box.right > rail.right) {
        thumbs.scrollTo({left: thumbs.scrollLeft + box.left - rail.left - (rail.width - box.width) / 2, behavior: 'auto'});
      }
    }
    function showPhoto(index, behavior = reduced ? 'auto' : 'smooth') {
      updateGallery(index);
      slides.scrollTo({left: slides.clientWidth * galleryIndex, behavior});
    }
    const unitDiscount = n => Math.round((n >= 3 ? 700 : n >= 2 ? 400 : 0) * rate);
    const bundleTotal = n => ids.slice(0, n).reduce((sum, id) => sum + Math.max(0, (byId.get(id) || byId.get(ids[0])).price - unitDiscount(n)), 0);
    const missingCount = () => ids.slice(0, count).filter(id => !id).length;
    function stockError() {
      if (missingCount()) return 'Please choose a color for every wallet.';
      const need = {};
      ids.slice(0, count).forEach(id => { need[id] = (need[id] || 0) + 1; });
      for (const [id, quantity] of Object.entries(need)) {
        const v = byId.get(id);
        if (!v?.available) return `${v?.title || 'This color'} is currently sold out. Please choose another color.`;
        if (v.tracked && quantity > v.quantity) return `Only ${v.quantity} ${v.title} wallet${v.quantity === 1 ? '' : 's'} available. Please choose another color for the remaining wallet.`;
      }
      return '';
    }
    function showError(message) {
      $('[data-error]').textContent = message;
      $('[data-error]').hidden = !message;
    }
    function selectedItems() {
      const quantities = new Map();
      ids.slice(0, count).filter(Boolean).forEach(id => quantities.set(id, (quantities.get(id) || 0) + 1));
      return [...quantities].map(([id, quantity]) => ({id, quantity}));
    }
    function syncExpress() {
      const [main, ...additional] = selectedItems();
      const variant = $('[data-express-variant]');
      const quantity = $('[data-express-quantity]');
      const changed = variant.value !== main.id || quantity.value !== String(main.quantity);
      variant.value = main.id;
      quantity.value = String(main.quantity);
      // Shopify's native multi-item checkout starts additional variants at index 1.
      const fields = additional.flatMap((item, index) => ['id', 'quantity'].map(key => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `shopify-additional-items[${index + 1}][${key}]`;
        input.value = String(item[key]);
        return input;
      }));
      $('[data-express-items]').replaceChildren(...fields);
      if (changed) {
        variant.dispatchEvent(new Event('change', {bubbles: true}));
        quantity.dispatchEvent(new Event('change', {bubbles: true}));
      }
    }
    function renderMix() {
      const mix = $('[data-mix]');
      mix.hidden = count === 1;
      mix.style.setProperty('--wallet-count', String(count));
      for (let i = 0; i < 3; i++) {
        let button = mix.querySelector(`[data-slot="${i}"]`);
        if (!button) {
          button = document.createElement('button'); button.type = 'button'; button.className = 'tlw-slot'; button.dataset.slot = String(i);
          button.innerHTML = `<span class="tlw-slot-number" aria-hidden="true">${i + 1}</span><img alt="" width="48" height="48"><span class="tlw-slot-empty" aria-hidden="true">+</span><span class="tlw-slot-label">Wallet ${i + 1}<strong></strong></span>`;
          mix.append(button);
        }
        const variant = byId.get(ids[i]);
        button.hidden = i >= count;
        button.setAttribute('aria-pressed', String(i === activeSlot));
        button.setAttribute('aria-label', `Wallet ${i + 1}: ${variant?.title || 'Choose a color'}`);
        button.querySelector('strong').textContent = variant?.title || 'Choose color';
        const image = button.querySelector('img'); image.hidden = !variant;
        if (variant) image.src = variant.image;
        button.querySelector('.tlw-slot-empty').hidden = !!variant;
      }
    }
    function render() {
      renderMix();
      $$('[name="wallet-count"]').forEach(input => { input.checked = Number(input.value) === count; });
      try {
        history.replaceState({...history.state, tenLoveWallet: {version: 2, section: root.id, count, ids: [...ids], activeSlot}}, '');
      } catch (_) { /* Checkout remains usable if browser history storage is unavailable. */ }
      const v = byId.get(ids[0]);
      $('[data-color-legend]').firstChild.textContent = count === 1 ? 'Your color: ' : 'Choose a color for ';
      $('[data-color-name]').textContent = count === 1 ? v.title : `Wallet ${activeSlot + 1}`;
      const help = $('[data-color-help]');
      help.hidden = count === 1;
      help.textContent = missingCount()
        ? `Tap a photo below. Pick different colors or the same color again.`
        : `All ${count} chosen. Tap a numbered wallet to change its color.`;
      $('[data-variant-input]').value = String(v.id);
      const stickyImages = ids.slice(0, count).filter(Boolean).map(id => {
        const image = document.createElement('img'); image.src = byId.get(id).image;
        image.alt = `${byId.get(id).title} wallet`; image.width = 48; image.height = 48; return image;
      });
      $('[data-sticky-images]').replaceChildren(...stickyImages);
      $('[data-sticky-title]').textContent = count === 1 ? v.title : `${count - missingCount()} of ${count} chosen`;
      $('[data-sticky-total]').textContent = `${money(bundleTotal(count))} total`;
      $('[data-price]').textContent = money(bundleTotal(count) / count);
      $('[data-price-note]').textContent = `${money(bundleTotal(count))} total for ${count} wallet${count === 1 ? '' : 's'}`;
      $$('[data-color]').forEach(button => {
        const id = button.dataset.color;
        const selected = ids.slice(0, count).filter(value => value === id).length;
        button.setAttribute('aria-pressed', String(selected > 0));
        button.classList.toggle('is-current', ids[activeSlot] === id);
        const variant = byId.get(id);
        button.setAttribute('aria-label', `${variant.title}${!variant.available ? ', sold out' : count > 1 ? `, ${selected} in bundle. Choose for wallet ${activeSlot + 1}` : ''}`);
        const badge = button.querySelector('[data-color-count]');
        badge.hidden = count === 1 || selected === 0;
        badge.textContent = `\u00d7${selected}`;
      });
      for (const n of [1,2,3]) {
        const price = Math.max(0,v.price - unitDiscount(n));
        $(`[data-tier-each="${n}"]`).textContent = money(price);
        $(`[data-tier-total="${n}"]`).textContent = money(price * n);
        if (n > 1) {
          $(`[data-tier-regular="${n}"]`).textContent = money(v.price * n);
          $(`[data-tier-save="${n}"]`).textContent = `Save ${money(unitDiscount(n) * n)}`;
        }
      }
      const error = stockError();
      showError(missingCount() ? '' : error);
      syncExpress();
      express.hidden = busy || !!error;
      $$('[data-buy], [data-add]').forEach(button => { button.disabled = busy || !!error; button.setAttribute('aria-busy', String(busy)); });
      $('[data-sticky-buy]').disabled = busy || (!!error && !missingCount());
      $('[data-sticky-buy]').setAttribute('aria-busy', String(busy));
      $('[data-buy]').innerHTML = busy ? 'Opening your bag…' : missingCount() ? `Choose ${missingCount()} more color${missingCount() === 1 ? '' : 's'}` : 'Buy Now <span aria-hidden="true">→</span>';
      $('[data-sticky-buy]').textContent = busy ? 'One moment…' : missingCount() ? 'Choose colors' : 'Buy Now →';
      $('[data-sticky]').hidden = !stickyEligible;
    }
    function selectMain(id) {
      if (!byId.get(id)?.available) return;
      ids[activeSlot] = id;
      if (activeSlot === 0) {
        const url = new URL(location.href); url.searchParams.set('variant', id); history.replaceState(history.state, '', url);
      }
      const index = photos.findIndex(photo => photo.dataset.slideVariant === id);
      if (index >= 0) showPhoto(index);
      const next = ids.slice(0, count).findIndex(value => !value);
      if (next >= 0) activeSlot = next;
      render();
    }
    $$('[data-color]').forEach(button => button.addEventListener('click', () => selectMain(button.dataset.color)));
    $$('[data-explore-color]').forEach(link => link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      selectMain(link.dataset.exploreColor);
      $('#WalletBuy').scrollIntoView({block: 'start', behavior: reduced ? 'auto' : 'smooth'});
      $(`[data-color="${link.dataset.exploreColor}"]`).focus({preventScroll: true});
    }));
    $$('[name="wallet-count"]').forEach(input => input.addEventListener('change', () => {
      count = Number(input.value);
      const next = ids.slice(0, count).findIndex(id => !id);
      activeSlot = next >= 0 ? next : Math.min(activeSlot, count - 1);
      render();
    }));
    $('[data-mix]').addEventListener('click', event => {
      const button = event.target.closest('[data-slot]'); if (!button) return;
      activeSlot = Number(button.dataset.slot);
      const index = photos.findIndex(photo => photo.dataset.slideVariant === ids[activeSlot]);
      if (index >= 0) showPhoto(index);
      render();
    });
    async function purchase(checkout) {
      if (busy) return;
      const error = stockError(); if (error) { showError(error); return; }
      busy = true; render();
      try {
        const response = await fetch(`${route}cart/add.js`, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:selectedItems().map(({id,quantity}) => ({id:Number(id),quantity}))})});
        const data = await response.json();
        if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || 'We could not add your wallet. Please try again.');
        location.assign(checkout ? `${route}checkout` : `${route}cart`);
      } catch (error) { busy = false; render(); showError(error.message || 'Please check your connection and try again.'); $('[data-error]').scrollIntoView({block:'center',behavior:'smooth'}); }
    }
    // Isolate this multi-color form from legacy single-variant cart interceptors.
    form.addEventListener('submit', event => { event.preventDefault(); event.stopImmediatePropagation(); purchase(true); }, true);
    $('[data-add]').addEventListener('click', () => purchase(false));
    $('[data-sticky-buy]').addEventListener('click', () => {
      if (!missingCount()) { purchase(true); return; }
      $('[data-color-picker]').scrollIntoView({block: 'center', behavior: reduced ? 'auto' : 'smooth'});
      $(`[data-slot="${activeSlot}"]`).focus({preventScroll: true});
    });
    $$('[data-slide]').forEach(button => button.addEventListener('click', () => showPhoto(Number(button.dataset.slide))));
    let frame;
    slides.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(() => { if (slides.clientWidth && slides.clientWidth === galleryWidth) updateGallery(Math.round(slides.scrollLeft / slides.clientWidth)); }); }, {passive:true});
    slides.addEventListener('keydown', event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); slides.scrollBy({left:slides.clientWidth*(event.key==='ArrowRight'?1:-1),behavior:reduced?'auto':'smooth'}); } });
    // Keep the chosen photograph aligned when a phone rotates or the layout resizes.
    const galleryObserver = new ResizeObserver(() => {
      if (slides.clientWidth && slides.clientWidth !== galleryWidth) {
        cancelAnimationFrame(frame);
        galleryWidth = slides.clientWidth;
        showPhoto(galleryIndex, 'instant');
      }
    });
    galleryObserver.observe(slides);
    const dialog = $('[data-lightbox]');
    $$('[data-zoom]').forEach(button => button.addEventListener('click', () => { $('[data-lightbox-image]').src = button.querySelector('img').src; $('[data-lightbox-image]').alt = button.querySelector('img').alt; dialog.showModal(); }));
    $('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    const observer = new IntersectionObserver(entries => { stickyEligible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0; $('[data-sticky]').hidden = !stickyEligible; }, {threshold:0});
    observer.observe($('[data-buy]'));
    window.addEventListener('pageshow', () => { busy = false; render(); });
    $$('.tlw-enhanced').forEach(element => { element.hidden = false; });
    if (currency !== 'USD') $('[data-discount-note]').textContent = 'Estimated bundle total in your currency. Final savings are calculated at checkout.';
    render();
  }
  document.querySelectorAll('[data-wallet]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wallet]').forEach(init));
})();
